export default {
  default: () => import("/codebuild/output/src3418197868/src/src/layouts/default.vue").then(m => m.default || m)
}